/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Figure_CaptionInputs */

const en_gc_search_guides_what_is_gridcraft_sections_2_figure_caption = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Figure_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pivot view reorganizes source records into a summary. Screenshot: ArtCraft.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_2_figure_caption = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Figure_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据透视视图把源记录重新组织为汇总结果。截图来源：ArtCraft。`)
};

/**
* | output |
* | --- |
* | "A pivot view reorganizes source records into a summary. Screenshot: ArtCraft." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Figure_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_2_figure_caption = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Figure_CaptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Figure_CaptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_2_figure_caption(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_2_figure_caption(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_2_figure_caption as "gc.search_guides.what_is_gridcraft.sections.2.figure.caption" }